var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "website-traffic-chart",
      class: { fullscreen: _vm.fullScreen },
    },
    [
      _vm.fullScreen
        ? _c(
            "div",
            { staticClass: "title" },
            [
              _c("ChartDoddleIcon"),
              _vm._v(" "),
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.websiteTraffic")))]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "toolbar" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.chartView") },
                      expression: "{ content: $t('report.chartView') }",
                    },
                  ],
                  attrs: {
                    classNames: _vm.tableMode ? "" : "selected",
                    onClick: function () {
                      return (_vm.tableMode = false)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("insights")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.tableView") },
                      expression: "{ content: $t('report.tableView') }",
                    },
                  ],
                  attrs: {
                    classNames: _vm.tableMode ? "selected" : "",
                    onClick: function () {
                      return (_vm.tableMode = true)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("table_view")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.download") },
                      expression: "{ content: $t('report.download') }",
                    },
                  ],
                  attrs: { onClick: _vm.exportToExcel },
                },
                [_c("md-icon", [_vm._v("download")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.fullScreen") },
                      expression: "{ content: $t('report.fullScreen') }",
                    },
                  ],
                  attrs: { onClick: _vm.switchToFullScreenMode },
                },
                [
                  !_vm.fullScreen
                    ? _c("md-icon", [_vm._v("fullscreen")])
                    : _c("md-icon", [_vm._v("fullscreen_exit")]),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      !_vm.tableMode
        ? _c("EChartsLine", {
            attrs: {
              labels: _vm.getXAxisData(),
              datasets: _vm.getChartDatasets(),
              height: 320,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.tableMode
        ? _c("TableView", {
            attrs: { cols: _vm.getCols(), rows: _vm.getRows() },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "stats" },
        [
          _c("StatCard", {
            staticClass: "total-visitor-count",
            attrs: {
              title: _vm.$t("report.total"),
              value: _vm.stats.TotalVisitorCount,
              unit: "visitor",
            },
          }),
          _vm._v(" "),
          _c("StatCard", {
            staticClass: "average-visitor-count",
            attrs: {
              title: _vm.getTitle("average"),
              value: _vm.stats.AverageVisitorCount,
              unit: "visitor",
            },
          }),
          _vm._v(" "),
          _c("StatCard", {
            staticClass: "max-visitor-count",
            attrs: {
              title: _vm.getTitle("max"),
              value: _vm.stats.MaxVisitorCount,
              unit: "visitor",
            },
          }),
          _vm._v(" "),
          _c("StatCard", {
            staticClass: "min-visitor-count",
            attrs: {
              title: _vm.getTitle("min"),
              value: _vm.stats.MinVisitorCount,
              unit: "visitor",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }